module.exports = __webpack_public_path__ + "img/add_bonus.d7efdce7.svg";